<template>
	<div id="wrapper" class="pb-5 mb-5 h-100vh">
	<section class="scrollbar rgtrStps">
	    <div class="container registerStes-form">
	        <div class="row align-items-center justify-content-center h-100">
	            <div class="col-12 col-lg-10">
	            	<loader v-if="pageLoader && !$parent.pageLoader"></loader>
	                <div class="customFotm position-relative stepsRegular bg-white border-radius-5 p-md-5 p-3">
	                	<span class="alert alert-danger" v-if="submitted && errors.has('memberShipType')">Please select the payment methods</span>
                    	<h2 class="text-center themecolor mb-4">Payment Method</h2>
                        <div class="row my-5" v-if="options.PAYMENT_METHODS">
                            <div class="col-12 col-md-4" v-for="item in options.PAYMENT_METHODS">
		                        <div class="visitTime position-relative" :class="[{'active': mode == item.id}]">
		                            <label class="customRadiobox"> 
		                            	<img class="minH" :src="'../../../../static/website/images/'+$env_var.payment_methods[item.id].img +'.svg'" alt="Images">
		                            	<span class="mt-3 d-block">{{item.method}}</span>
		                                <input type="radio" :value="item.id" v-model="mode" name="mode" v-validate="'required'">
		                                <span class="checkmark"></span>
		                            </label>
		                        </div>
		                    </div>
                    	</div>
                        <div class="col-12">
                            <div class="form-group mt-4 text-center">
                                <button class="btn btn-link btn-blue" @click.stop.prevent="submit()">Submit</button>
                            </div>
                        </div>
	                </div>
	            </div>
	        </div>
	    </div>
	</section>
	</div>
</template>
<script>
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	export default {
		name: 'payment-mode',
		data() {
			return {
				pageLoader: false,
                notification_msg:'',
                notification_type:'',
				submitted: false,
				mode:'',
			}
		},
		components: {},
		props:{
			options: {
		      default: {}
		    }
		},
		methods: {
			...mapActions({
				_runRegisterStep2: types.RUN_REGISTER_STEP2,
				_runGetRegisterStepData: types.RUN_GET_USER_REGISTERATION_STEP_DATA,
			}),
			changeMembership(){
				if(this.memberShip != 1){
					this.member_type = ''
				}
			},
			submit() {
				const _that = this
				this.submitted = true;
				this.$validator.validate().then(valid => {
					if (valid) {
						let input_json = {
							'globalParams': {
								"payment_method_id" : _that.mode
							},
							'localParams': {
								"parameter": _that
							}
						}
						_that._runRegisterStep2(input_json)
					}
				})
			}
		},
		created(){
			this._runGetRegisterStepData({'globalParams': {"step" : "2"},'localParams': {"parameter": this,'step':'2'}})
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/registerSteps/step2.vue